import { Component } from '@angular/core';
import { Params, Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'dcc-device-monitoring-modal-link',
  template: `
    <div class="cell-modal-link">
      <a class="cell-modal-link__link" (click)="navigateToProfile()">{{ cellValue }}</a>
    </div>
  `,
})
export class DeviceMonitoringModalLinkComponent
  implements ICellRendererAngularComp
{
  cellValue: string;

  constructor(private router: Router) {}

  navigateToProfile() {
    this.router.navigate(['/insights/device', this.cellValue], {
      queryParamsHandling: 'preserve',
      state: {
        returnUrl: this.router.url.split('?')[0],
        returnQueryParams: this.getQueryParams(),
      },
    });
  }

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }

  private getQueryParams(): Params {
    const urlTree = this.router.parseUrl(this.router.url);
    return urlTree.queryParams || {};
  }
}
